import { Grid, Typography, styled } from "@material-ui/core";

export const ColumnControl = styled(Grid)(({ theme }) => ({
  margin: theme.spacing(2, 0),
}));

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontSize: "0.8rem",
  fontWeight: 500,
  textTransform: "uppercase",
  margin: theme.spacing(1, 0, 4, 0),
}));

export const RedText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
}));
